import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=6874e1c8&"
import script from "./survey.vue?vue&type=script&lang=ts&"
export * from "./survey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6874e1c8')) {
      api.createRecord('6874e1c8', component.options)
    } else {
      api.reload('6874e1c8', component.options)
    }
    module.hot.accept("./survey.vue?vue&type=template&id=6874e1c8&", function () {
      api.rerender('6874e1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/survey.vue"
export default component.exports